import {useFeatureFlag} from "../../featureFlag/hooks/fleatureFlag";
import {ONE_TRUST_FEATURE_FLAG} from "../../featureFlag/constants";
import {OneTrustScripts} from "./oneTrustScripts";
import {EvidonScripts} from "./evidonScripts";

export const CookieConsentScripts = () => {
  const isOneTrustEnabled = useFeatureFlag(ONE_TRUST_FEATURE_FLAG);

  return isOneTrustEnabled ? <OneTrustScripts /> : <EvidonScripts />;
};
